import { render, staticRenderFns } from "./TopButtons.vue?vue&type=template&id=b240884e&"
import script from "./TopButtons.vue?vue&type=script&lang=js&"
export * from "./TopButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports